module.exports = __webpack_public_path__ + "static/media/map.7f7e3763.svg";